import { render, staticRenderFns } from "./EntityFolderIcon.vue?vue&type=template&id=591c5f86&"
import script from "./EntityFolderIcon.vue?vue&type=script&lang=ts&"
export * from "./EntityFolderIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports